export enum DocState {
    empty = 'DOCUMENT_EMPTY',
    received = 'DOCUMENT_RECEIVED',
    brokerUnapproved = 'DOCUMENT_BROKER_UNAPPROVED',
    disabled = 'DOCUMENT_DISABLED',
    brokerApproved = 'DOCUMENT_BROKER_APPROVED',
    lenderAccepted = 'DOCUMENT_LENDER_ACCEPTED'
}
